import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import firebaseApp from "../firebase";

const storage = getStorage(firebaseApp);

class FirebaseStorage {
    static uploadImage = async (
        action: "posts" | "profile",
        userId: string,
        file: File,
        postId?: string
    ): Promise<string> => {
        const safeName = `${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.-]/g, "_")}`;
        const path =
            action === "posts" && postId
                ? `${userId}/${action}/${postId}/${safeName}`
                : `${userId}/${action}/${safeName}`;
        const storageRef = ref(storage, path);
        await uploadBytes(storageRef, file);
        return getDownloadURL(storageRef);
    };

    static getImagesUrl = async (
        action: "posts" | "profile",
        userId: string,
        files: File[],
        postId?: string
    ): Promise<string[]> => {
        const urls = await Promise.all(
            files.map((file, index) => {
                const safeName = `${Date.now()}_${index}_${file.name.replace(/[^a-zA-Z0-9.-]/g, "_")}`;
                const path =
                    action === "posts" && postId
                        ? `${userId}/${action}/${postId}/${safeName}`
                        : `${userId}/${action}/${safeName}`;
                const storageRef = ref(storage, path);
                console.log("storageRef", storageRef);
                return uploadBytes(storageRef, file).then(() => getDownloadURL(storageRef));
            })
        );
        console.log("urls", urls);
        return urls;
    };
}

export default FirebaseStorage;
